import { render } from "./AuthenticatedTabs.vue?vue&type=template&id=0338b58c&scoped=true&ts=true"
import script from "./AuthenticatedTabs.vue?vue&type=script&lang=ts"
export * from "./AuthenticatedTabs.vue?vue&type=script&lang=ts"

import "./AuthenticatedTabs.vue?vue&type=style&index=0&id=0338b58c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0338b58c"]])

export default __exports__